export enum ACTUALBUDGET {
  ACTUAL = 'actual',
  BUDGET = 'budget',
}
export enum PAGE {
  FINANCE = 'FINANCE',
  STAFF = 'DC_5_STAFF',
  FACILITIES = 'DC_3_FACILITIES',
  TEAMS = 'DC_7_COMPONENT_NAME',
  PLAYERS = 'DC_8_COMPONENT_NAME',
}
export interface SingleOption {
  id: number;
  name: string;
}
export interface SingleValueOption extends SingleOption {
  value: number;
}
export interface SingleDropdown {
  options: SingleOption[];
  value: SingleOption | undefined | any;
}
export interface ClubOptionDropdown {
  options: ClubOption[];
  value: ClubOption | undefined;
}

export interface MultiDropdown {
  options: SingleOption[];
  value: SingleOption[];
}
export interface MultiValueDropdown {
  options: SingleValueOption[];
  value: SingleValueOption[];
}

export interface TwoSingleDropdown {
  value: SingleOption | undefined | any;
  secondValue: SingleOption | undefined;
  secondOptions?: any;
}

export interface GlobalStoreType {
  explorePage: any;
  selectedPage: PAGE;
  playersResponse: any;
  playersCountResponse: any;
  supportFundResponse?: any;
  facilityResponse: any;
  teamsResponse: any;
  staffResponse: any;
  financeResponse: any;
  colorsList: Record<string, string>;
  leaguesHistory: any,
  globalFilterOptions: {
    league: MultiDropdown;
    rating: MultiValueDropdown;
    year: SingleDropdown;
    club: ClubOptionDropdown;
    actualOrBudget: ACTUALBUDGET;
    search: string;
  };
  timeLineData: {
    timeLine: TwoSingleDropdown;
  };
  roiData: {
    roiInvestment: TwoSingleDropdown;
    roiReturn: SingleDropdown | any;
  };
  ranking: any;
  staffRanking: { rankingLabels: string[]; rank: any };
  facilityRanking: { rankingLabels: string[]; rank: any };
  teamsRanking: { rankingLabels: string[]; rank: any };
  playersRanking: { rankingLabels: string[]; rank: any };
  benchmarkingData: {
    benchmarking: TwoSingleDropdown;
  };
  departments: any;
}

interface Club {
  name: string;
  currentRating: number;
  imagePath: string;
  color: string;
  textColor: string;
  leagueId: number;
  japaneseName: string | null;
  cycle: number;
  targetDate: string;
  licenceCycle: number;
  league: any; // You may want to define a specific interface for "league" if needed
  cycleData: any; // You may want to define a specific interface for "cycleData" if needed
  clubDefaultGoals: any; // You may want to define a specific interface for "clubDefaultGoals" if needed
  clubDefaultObjectives: any; // You may want to define a specific interface for "clubDefaultObjectives" if needed
  kpis: any; // You may want to define a specific interface for "kpis" if needed
  clubDefaultKpis: any; // You may want to define a specific interface for "clubDefaultKpis" if needed
  users: any; // You may want to define a specific interface for "users" if needed
  clubDepartments: any; // You may want to define a specific interface for "clubDepartments" if needed
  id: number;
  isDeleted: boolean;
  createdDate: string;
  updatedDate: string;
}

export interface ClubData {
  id: number;
  mandatory: boolean;
  year: string;
  type: string;
  subType: string | null;
  name: string;
  otherExpenseName: string;
  currentYear: number;
  nextYear: number;
  order: number;
  clubId: number;
  club: Club;
}

export interface ClubOption {
  id: string;
  name: string;
  currentRating: string;
  targetRating: string;
  imageUrl: string;
  color: string;
  textColor: string;
  leagueId: string;
  selfAssessment: string;
  evaluation: string;
  evaluationRAGB: string;
  perfPlan: string;
  perfPlanStatus: string;
  perfPlanRAGB: string;
  licence: string;
  licenceEvaluation: string;
  licenceStatus: string;
  licenceRAGB: string;
}
